export const navLinks = [
  { label: 'How it works', href: '/#how-it-works' },
  { label: 'Resources', href: '/#resources' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'Blog', href: '/blog', external: true },
];

export const heroSuggestions = [
  'a website for my plumbing business in Brisbane',
  'an electrician site with a quote form',
  'a lawn care business landing page',
  'a cleaning business site for the Sydney inner west',
  'a website for my mobile car detailing business',
];

// Honest placeholder — no fabricated brand endorsements.
export const asFeaturedIn = [
  'Indie Hackers',
  'Product Hunt',
  'Makerlog',
  'Solo Founder',
  'No-Code List',
  'Builder Weekly',
];

export const platformSteps = [
  {
    number: '01',
    title: 'Describe your idea in your own words.',
    description:
      'No code, no diagrams, no jargon. Just tell YouBuild what you want to build in plain English — the way you’d explain it to a friend.',
  },
  {
    number: '02',
    title: 'Refine it until it feels right.',
    description:
      'Tweak the copy, move things around, change the colours. YouBuild rebuilds the page in real time so you can iterate the way a designer would — without being one.',
  },
  {
    number: '03',
    title: 'Publish and share it with the world.',
    description:
      'When you’re ready, publish to a real URL in one click. Hosting, SSL, and everything else is handled — so you can focus on your idea, not the plumbing.',
  },
];

export const platformFeatures = [
  {
    title: 'Hosting, handled for you',
    description:
      'Publish to a real, secure web address in a single click. We take care of hosting, SSL, and uptime so you don’t have to think about it.',
    icon: 'Cloud',
    tag: 'Hosting',
  },
  {
    title: 'Every enquiry, straight to you',
    description:
      'Quote requests from your page land in your Leads inbox and your email — no integrations to set up, so no lead slips through.',
    icon: 'Inbox',
    tag: 'Leads',
  },
  {
    title: 'Built to get found on Google',
    description:
      'Every page ships with the search essentials — clean structure, a sitemap, and rich business data — so Google understands your trade, your services, and your area.',
    icon: 'Search',
    tag: 'Get found',
  },
  {
    title: 'Safe and secure, by default',
    description:
      'Your work and your customers’ data are protected with sensible security defaults — no security engineer required.',
    icon: 'Shield',
    tag: 'Security',
  },
  {
    title: 'Build from anywhere',
    description:
      'Sketch an idea on your phone at lunch, refine it on your laptop at night. YouBuild works wherever you do.',
    icon: 'Globe',
    tag: 'Anywhere',
  },
];

// Generic, illustrative quotes — no real names, companies, or metrics.
export const earlyBuilderQuotes = [
  {
    quote:
      '“I’d been sitting on this idea for two years because I couldn’t code. In one weekend I had a real page my first customer signed up on.”',
    role: 'A solo founder • illustrative example',
    accent: 'from-orange-100 to-rose-100',
    initial: 'S',
  },
  {
    quote:
      '“The fact that I could just describe what I wanted, in my own words, and see it appear — that was the moment it clicked for me.”',
    role: 'A creative freelancer • illustrative example',
    accent: 'from-amber-100 to-yellow-50',
    initial: 'C',
  },
  {
    quote:
      '“I’m not a developer. I don’t want to be a developer. I just wanted a proper website for my small business — and now I have one.”',
    role: 'A small business owner • illustrative example',
    accent: 'from-teal-50 to-emerald-100',
    initial: 'B',
  },
];

export const founderNote = {
  heading: 'From a non-technical founder, for non-technical builders.',
  body:
    'I built YouBuild because I was tired of watching people with brilliant ideas get stuck at the same wall I did — the code. I’m not an engineer. I learned to build with AI, and this is the platform I wish I’d had on day one. If I can ship real software this way, so can you.',
};

// Footer link groups. Every entry MUST resolve to a real route or on-page
// anchor. Dead links are not welcome here. `type` controls how the Footer
// renders it: 'anchor' = same-page hash (works when we're on `/`; also handled
// with a Link fallback), 'route' = react-router Link, 'mailto' = external mail.
export const footerLinks = {
  Product: [
    { label: 'How it works', href: '/#how-it-works', type: 'anchor' },
    { label: 'Pricing', href: '/#pricing', type: 'anchor' },
    { label: 'Resources', href: '/#resources', type: 'anchor' },
  ],
  Company: [
    { label: 'Blog', href: '/blog', type: 'route' },
    { label: 'Contact', href: 'mailto:ginacastela62@gmail.com', type: 'mailto' },
  ],
  Legal: [
    { label: 'Privacy', href: '/privacy', type: 'route' },
    { label: 'Terms', href: '/terms', type: 'route' },
  ],
};
